<template>
    <div class="container px-2 px-lg-4">
        <BaseHeader :title="title">
        </BaseHeader>
        <BaseFilter removeSearchBar>
            <div class="item action btn-group">
                <BaseButton class="btn-filter btn-success w-100" data-bs-toggle="dropdown" ariahashpopup="true" aria-expanded="true" data-bs-auto-close="outside">
                    <font-awesome-icon icon="far fa-filter" />
                    Filtros
                    <span class="filters_qty_active">{{ totalFilters }}</span>
                </BaseButton>
                <div class="dropdown-menu dropdown-menu-end py-0"  aria-labelledby="dropdownMenu">
                    <FilterReferrals @filters="filters" :initialFilters="initialFilters" @filtersQty="filtersQty"/>
                </div>
                <BaseButton class="btn-success w-100 dropdown-toggle" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    Exportar
                </BaseButton>
                <div class="dropdown-menu" x-placement="bottom-start" aria-labelledby="dropdownMenu">
                    <a class="dropdown-item d-flex justify-content-center flex-column" target="_blank" :href="exportUrl + 'csv' + exportParams">CSV</a>
                    <a class="dropdown-item d-flex justify-content-center flex-column" target="_blank" :href="exportUrl + 'xls' + exportParams">XLS</a>
                </div>
            </div>
        </BaseFilter>
        <BaseTable class="no_top_radius" :columns="tableColumns" :paginate="paginate" :isLoading="isLoading" :qty="paymentMethods.length"  @changePage="changePage" :noActions="true">
            <tr v-for="(paymentMethod, key) in reportStore.paymentMethods" :key="key">
                <td>{{ paymentMethod.title }}</td>
                <td>{{ paymentMethod.percentage }}%</td>
                <td>{{ globalStore.formatMoney(paymentMethod.amount) }}</td>
                <td>{{ globalStore.formatMoney(paymentMethod.comission) }}</td>
            </tr>
        </BaseTable>
    </div>
</template>
<script setup>
const title = {title: 'Relatório: Métodos de pagamento', icon: 'fa-chart-simple'};
import FilterReferrals from '@/components/includes/reports/ReportsFilter';
import BaseFilter from '@/components/ui/BaseFilter';

import { ref, onBeforeMount, watch } from 'vue';
import { storeToRefs } from 'pinia';
import qs from "qs";

import { useReportStore } from '@/stores/report';
const reportStore = useReportStore();
const { paymentMethods } = storeToRefs(reportStore);

import { useGlobalStore } from '@/stores/global';
const globalStore = useGlobalStore();
const { defaultStore } = storeToRefs(globalStore);

const tableColumns = ['Método de pagamento', 'Porcentagem', 'Valor', 'Comissão'];

const isLoading = ref(false);

const paginate = {
    current_page: '1',
    from: '1',
    last_page: '1',
}

import { useRouter, useRoute } from 'vue-router';
const route = useRoute();
const router = useRouter();

let initialFilters = null;

onBeforeMount(() => {
    if(!globalStore.hasPermissionTo('report_payment_methods')) {
        return router.push('/403');
    }

    if(reportStore.paymentMethods.length == undefined){
        isLoading.value = true;
    }

    if(route.query.page || route.query.date_start || route.query.date_end) {
        Object.keys(reportStore.payment_rep_filters).forEach((key) => {
            let currentThing = route.query[key];
            reportStore.payment_rep_filters[key] = '';
            reportStore.payment_rep_filters[key] = currentThing;
            
            initialFilters = reportStore.payment_rep_filters;
            let param = route.query[key];
            reportStore.payment_rep_filters[key] = (param == undefined) ? null : param;

        });
    }

    loadPaymentMethods().then(() => {
        isLoading.value = false;
    });

    if(reportStore.payment_rep_filters.date_start && reportStore.payment_rep_filters.date_end){
        initialFilters = {};
        initialFilters['date_range'] = reportStore.payment_rep_filters.date_start + '@' + reportStore.payment_rep_filters.date_end
    }

});

let isChangingPage = false;
async function changePage(page) {
    if(isChangingPage) return;
    reportStore.payment_rep_filters.page = page;
    globalStore.loader('show');
    isChangingPage = true;
    loadPaymentMethods().then(() => {
        isChangingPage = false;
        window.scrollTo({ top:0, left:0, behavior: "instant"});
    });
}

// eslint-disable-next-line
const exportUrl = ref(process.env.VUE_APP_API_URL + 'reports/payment-methods/export/');

const exportParams = ref('');

let loadDefaultStore = false;
watch(defaultStore, function () {
    if(!loadDefaultStore) {
        loadDefaultStore = true;
        reportStore.payment_rep_filters.page = null;
        globalStore.loader('show');
        loadPaymentMethods().then(()=> {
            globalStore.loader('hide');
            loadDefaultStore = false;
        });
    }
});

async function loadPaymentMethods() {
    let usedParams = {};
    if(initialFilters){
        initialFilters.date_range = null
    }

    Object.keys(reportStore.payment_rep_filters).forEach((key) => {
        if(reportStore.payment_rep_filters[key] != null && reportStore.payment_rep_filters[key] != '') {
            let currentParams = {
                ...usedParams,
                [key]: reportStore.payment_rep_filters[key]
            };
            usedParams =  currentParams;
        }
    });

    router.replace({query: usedParams});
    exportParams.value = (usedParams) ? '?' + qs.stringify(usedParams, { arrayFormat: "brackets" }) : '';
    await reportStore.tryPaymentMethods(reportStore.payment_rep_filters);
    globalStore.loader('hide');
}

const totalFilters = ref(0);

function filtersQty(r) {
    totalFilters.value = r;
}

function filters(r) {
    Object.keys(r).forEach((key) => {
        reportStore.payment_rep_filters[key] = r[key];
    });
    globalStore.loader('show');
    loadPaymentMethods();
}

</script>

<style scoped>

.filters_qty_active{
    background-color: #7ad563;
    padding: 0px 6px;
    font-size: 12px;
    color: white;
    border-radius: 40px;
    margin-left: 9px;
}

.base-title .action {
    flex: 0 0 225px!important;
}

.btn-filter{
    margin-right: 10px;
}

.bold{
    font-weight: bold; 
}

</style>